import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid bg-white p-3 mb-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-lg-6" }
const _hoisted_4 = { class: "main-heading m-3" }
const _hoisted_5 = {
  class: "row",
  style: {"min-height":"40vh"}
}
const _hoisted_6 = {
  class: "map-contact border rounded-3",
  id: "map",
  ref: "map"
}
const _hoisted_7 = { class: "row py-3" }
const _hoisted_8 = { class: "col-12 col-lg-6" }
const _hoisted_9 = { class: "row text-start p-3" }
const _hoisted_10 = { class: "text-warning mt-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h4", { class: "text-warning mt-3" }, "E-mail", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "tuthailandamulet@gmail.com", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", { class: "text-warning mt-3" }, "Tel", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "(+66) 08998-140-140, (+66) 0863-033-559", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h4", { class: "text-warning mt-3" }, "Line", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "0863033559 ", -1)
const _hoisted_17 = { class: "row p-4" }
const _hoisted_18 = {
  class: "col-12 col-lg-9 align-items-center center-highlight-item",
  "data-aos": "fade-up",
  "data-aos-offset": "300",
  "data-aos-delay": "150"
}
const _hoisted_19 = { class: "d-flex flex-wrap gap-4 m-2" }
const _hoisted_20 = {
  class: "text-decoration-none card border border-0",
  style: {"width":"18rem"}
}
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "card-body text-start" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { class: "badge badge-primary bg-secondary ms-1 mb-2" }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = ["href"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-facebook fs-4" }, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "ms-2" }, null, -1)
const _hoisted_32 = ["href"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-line fs-4" }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "ms-2" }, null, -1)
const _hoisted_36 = ["href"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-square-whatsapp fs-4" }, null, -1)
const _hoisted_38 = [
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.store.getters.localized('contact')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, null, 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.store.getters.localized('contect01')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.store.getters.localized('contect02')), 1),
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _hoisted_14,
          _hoisted_15,
          _hoisted_16
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (item, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_router_link, {
                to: `/service/${item._id}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "img-fluid p-3 rounded",
                    src: _ctx.imageUrl(item.image),
                    alt: "Card image cap",
                    style: {"aspect-ratio":"1/1"}
                  }, null, 8, _hoisted_21)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("div", _hoisted_22, [
                (_ctx.store.state.language==='th')
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_23, _toDisplayString(item.nameTH), 1))
                  : (_ctx.store.state.language==='ch')
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_24, _toDisplayString(item.nameCH), 1))
                    : (_openBlock(), _createElementBlock("h5", _hoisted_25, _toDisplayString(item.nameEN), 1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.languages, (lang) => {
                  return (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(lang), 1))
                }), 256)),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("a", {
                    target: "_blank",
                    href: `${item.facebook}`
                  }, _hoisted_30, 8, _hoisted_28),
                  _hoisted_31,
                  _createElementVNode("a", {
                    target: "_blank",
                    href: `${item.line}`
                  }, _hoisted_34, 8, _hoisted_32),
                  _hoisted_35,
                  _createElementVNode("a", {
                    target: "_blank",
                    href: `${item.wechat}`
                  }, _hoisted_38, 8, _hoisted_36)
                ])
              ])
            ]))
          }), 256))
        ])
      ])
    ])
  ]))
}